module.exports = __webpack_public_path__ + "img/icon-close.868b1ba6.svg";